import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {getRefinements} from '../../../utils/edap';

import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {reportSearchSubmit, showDatesPopup} from '../../../actions/search';
import {UNREFINED_KEY} from '../../../../shared/utils/listings';

function performClick(dispatch, eventrefinements, refinementKey, serpUrlFilters, modalTitle) {
    return (evt) => {
        evt.preventDefault();

        reportSearchSubmit(
            'properties-module',
            eventrefinements,
            'properties-module-search-carousel-card'
        );

        dispatch(showDatesPopup({
            searchLink: false,
            actionLocation: 'properties-module',
            eventrefinements,
            refinementKey,
            serpUrlFilters,
            title: modalTitle,
            tripleId: null
        }));
    };
}

export class SeeMorePropertiesRatioCardComponent extends PureComponent {
    render() {
        const {
            dispatch,
            propertyType,
            imageSrc,
            segmentKey,
            serpUrlFilters,
            aspectRatio = '4x3',
            cardTitle,
            lastCardUrl
        } = this.props;
        const eventrefinements = getRefinements({propertyType, refinementKey: segmentKey});

        return (<a href={lastCardUrl} onClick={performClick(dispatch, eventrefinements, segmentKey, serpUrlFilters, cardTitle)}>
            <div className="SeeMorePropertiesCard" >
                <AspectRatioCard aspectRatio={aspectRatio} key={imageSrc} >
                    <div data-slot={'figure'} className="SeeMorePropertiesCard__content">
                        <div className="SeeMorePropertiesCard__overlay bg-brand"/>
                    </div>
                </AspectRatioCard>
                <h4 className="SeeMorePropertiesCard__title">{cardTitle}</h4>
            </div>
        </a>);
    }
}

export function mapStateToProps(state) {
    return {
        propertyType: state.destination.propertyType,
        inventoryCount: state.destination.segmentFilters.inventoryCount || state.destination.inventoryCount,
        abacus: state.abacus,
        segmentKey: state.destination.segmentFilters.key || UNREFINED_KEY,
        serpUrlFilters: state.destination.serpUrlFilters,
        cardTitle: state.modules.searchMessages.cardTitle
    };
}

export const SeeMorePropertiesRatioCard =
    connect(mapStateToProps)(SeeMorePropertiesRatioCardComponent);
export default SeeMorePropertiesRatioCard;
